// components/scrollable-listings/scrollable-listings.tsx
import React, { useRef } from 'react';
import { Icon, ListingListItem } from '@requity-homes/component-library';
import { Listing } from '../../graphql/generated';

interface ScrollableListingsProps {
  listings: Listing[];
  repliersCdnUrl: string;
}

export const ScrollableListingsList: React.FC<ScrollableListingsProps> = ({
  listings,
  repliersCdnUrl,
}) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const scrollLeft = () => {
    scrollContainerRef.current.scrollBy({
      left: -400,
      behavior: 'smooth',
    });
  };

  const scrollRight = () => {
    scrollContainerRef.current.scrollBy({
      left: 400,
      behavior: 'smooth',
    });
  };

  return (
    <div className="relative">
      <div
        className="flex overflow-x-scroll space-x-4 p-4 scrollbar-hide"
        ref={scrollContainerRef}
      >
        {listings.map((listing: Listing) => (
          <ListingListItem
            className="h-full w-80"
            key={listing.mlsNumber}
            repliersCdnUrl={repliersCdnUrl}
            listing={listing}
            shouldOpenInNewWindow={true}
          />
        ))}
      </div>
      <button
        className="absolute left-0 p-2 bg-gray-800 text-white rounded-full top-1/2"
        onClick={scrollLeft}
      >
        <Icon glyph="chevronLeft" className="h-6 w-6" />
      </button>
      <button
        className="absolute right-0 p-2 bg-gray-800 text-white rounded-full top-1/2"
        onClick={scrollRight}
      >
        <Icon glyph="chevronRight" className="h-6 w-6" />
      </button>
    </div>
  );
};
